<style>
.v-timeline-item__opposite {
    align-self: flex-start;
}
</style>

<style scoped>
.quick-report-row .v-timeline-item__opposite {
    align-self: flex-start;
}
.number-circle {
    border: 2px solid var(--z-primary);
    color: var(--z-primary);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    background-color: white;
    box-sizing: content-box;
    position: relative;
}
.checkmark-circle {
    border: 2px solid var(--z-primary);
    background-color: var(--z-primary);
    color: var(--z-primarytext);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: -12px;
    top: 6px;
    font-size: 10px;
}
.checkmark {
    display: inline-block;
    font-size: 12px;
}
.period-title {
    font-weight: bold;
    text-align: center;
    border: 1px solid gray;
    border-radius: 5px;
    z-index: 0;
    background-color: white;
}
.team-image {
    width: 40px;
    height: 40px;
}
</style>

<template>
    <div v-if="loading && !match" class="d-flex align-center justify-center">
        <v-progress-circular size="20" indeterminate color="primary" width="2"></v-progress-circular>
    </div>
    <div  v-else>
        <div v-if="twoTeams">
            <teamsport-match-result :match="match" flat :show-live-result="true" :show-location="true" class="mb-8">
                <template #append-center-content v-if="canReportResult || referees.length">
                    <div class="d-flex flex-column justify-center mt-4">
                        <div v-if="canReportResult" class="mb-4">
                            <a href="" @click.prevent="showSetResultDialog = true">{{ $translate('Set result') }}</a>
                        </div>

                        <div class="font-weight-bold">{{$translate('Referees')}}</div>
                        <div v-for="referee in referees" :key="referee.id">
                            <span :class="{'mr-2': referee.mail || referee.phone }">
                                {{ referee.name }}
                                <template v-if="referee.mail || referee.phone && showUserDetails && !$vuetify.breakpoint.mobile">
                                    <span>:</span>
                                </template>
                            </span>
                            <span>
                                <a :href="'mailto:' + referee.mail" v-if="referee.mail && showUserDetails">
                                    <template v-if="$vuetify.breakpoint.mobile">
                                        <v-icon color="primary">mdi-email-outline</v-icon>
                                    </template>
                                    <template v-else>
                                        {{ referee.mail }}
                                    </template>
                                </a>
                                <template v-if="referee.mail && referee.phone && showUserDetails && !$vuetify.breakpoint.mobile">
                                    <span>,</span>
                                </template>
                            </span>
                            <a :href="'tel:' + referee.phone" v-if="referee.phone && showUserDetails" :class="{ 'ml-2': referee.mail }">
                                <template v-if="$vuetify.breakpoint.mobile">
                                    <v-icon color="primary">mdi-phone-outline</v-icon>
                                </template>
                                <template v-else>
                                    {{ referee.phone }}
                                </template>
                            </a>
                        </div>
                    </div>
                </template>
            </teamsport-match-result>

            <hr v-if="teamsSet" />

            <v-timeline v-if="twoTeams && teamsSet">
                <v-timeline-item class="text-right quick-report-row" color="primary" fill-dot icon="mdi-plus" large v-if="canLiveReport">
                    <template v-if="canLiveReportForAwayTeam && !$vuetify.breakpoint.mobile">
                        <div class="font-weight-bold">{{$translate('Quick report for {0}').format(match.teams[1].name)}}</div>
                        <a href="#" v-for="eventType in eventTypesForSport" :key="eventType.id" @click.prevent="addEvent(match.teams[1].id, eventType.id)" class="mr-2">{{eventType.name}}</a>
                    </template>
                    <template #opposite v-if="canLiveReportForHomeTeam && !$vuetify.breakpoint.mobile">
                        <div class="text-left">
                            <div class="font-weight-bold">{{$translate('Quick report for {0}').format(match.teams[0].name)}}</div>
                            <a href="#" v-for="eventType in eventTypesForSport" :key="eventType.id" @click.prevent="addEvent(match.teams[0].id, eventType.id)" class="mr-2">{{eventType.name}}</a>
                        </div>
                    </template>
                    <template #icon>
                        <v-icon color="primarytext" large @click="addEvent()">mdi-plus</v-icon>
                    </template>
                </v-timeline-item>

                <div class="d-flex justify-center mb-4" v-if="events && events.length == 0">
                    <div class="period-title text--disabled pa-1">
                        {{ $translate('No events') }}
                    </div>
                </div>
            </v-timeline>

            <template v-if="events && events.length > 0">
                <div v-for="timePeriod in timePeriods" :key="timePeriod.id">
                    <div class="d-flex justify-center" v-if="timePeriod.id && groupedEvents[timePeriod.id].length">
                        <div class="period-title text--disabled pa-1">
                            {{timePeriod.title}}
                        </div>
                    </div>
                    <v-timeline v-if="groupedEvents[timePeriod.id].length">
                        <v-timeline-item v-for="event in groupedEvents[timePeriod.id]" :key="event.id" fill-dot :left="event.home" :right="!event.home" :class="{'text-right': event.home}" :color="event.background_color">
                            <div class="font-weight-bold" :style="{ color: event.color }">{{event.title}}</div>
                            <div v-if="event.user">{{event.user.name}}</div>
                            <div v-if="event.comment" class="font-italic">{{event.comment}}</div>
                            <template #icon>
                                <v-btn icon color="primarytext" @click="changeEvent(event)">{{event.time}}</v-btn>
                            </template>
                        </v-timeline-item>
                    </v-timeline>
                </div>
            </template>

            <hr v-if="teamsSet && !isIndividualCompetition" />

            <v-row class="mt-2" v-if="teamsSet && !isIndividualCompetition">
                <v-col cols="12" md="6" v-for="(leaders, index) in [homeLeaders, awayLeaders]" :key="index">
                    <div class="font-weight-bold mb-2 align-center d-flex">
                        <img :src="'/api/public/image/get?size=200x200&type=team&id=' + match.teams[index].id" class="team-image mr-2" />
                        <div>{{match.teams[index].name}}</div>
                    </div>

                    <div v-if="match.teams[index].registration_answers">
                        <div v-for="question in questions" :key="question.name">
                            <div class="d-flex fill-width">
                                <div class="font-weight-bold">{{ question.name }}</div>
                                <div class="ml-2">{{ match.teams[index].registration_answers[question.name] }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="font-weight-bold mb-1">{{$translate('Leaders')}}</div>
                    <div class="d-flex" v-for="user in leaders" :key="user.id">
                        <div class="d-flex fill-width" style="margin: 0.15rem; position: relative; display: inline-flex;">
                            <v-avatar :size="20" class="mr-2">
                                <img :src="'/api/memberapi/image/member/get?size=50x50&id=' + user.id" class="user-image" />
                            </v-avatar>
                            <div class="flex-grow-1 text-truncate">{{ user.name }}</div>
                            
                            <a :href="'mailto:' + user.mail" v-if="user.mail && showUserDetails">
                                <template v-if="$vuetify.breakpoint.mobile">
                                    <v-icon color="primary">mdi-email-outline</v-icon>
                                </template>
                                <template v-else>
                                    {{ user.mail }}
                                </template>
                            </a>
                            <a :href="'tel:' + user.phone" v-if="user.phone && showUserDetails" :class="{ 'ml-2': user.mail }">
                                <template v-if="$vuetify.breakpoint.mobile">
                                    <v-icon color="primary">mdi-phone-outline</v-icon>
                                </template>
                                <template v-else>
                                    {{ user.phone }}
                                </template>
                            </a>
                            <v-icon
                                small
                                style="position: absolute; top: 0; left: 0; transform: translate(-50%, -50%);"
                                color="primary"
                                v-if="user.user_type == 'mainLeader'">
                                mdi-star
                            </v-icon>
                        </div>
                    </div>
                    <div class="font-weight-bold mt-2">{{$translate('Formation')}}</div>
                    <multi-column-list :items="getUsers(index)" @click="({item: user, $event}) => showPlayerDetails(user, match.teams[index].id, $event)" :clickable="showUserDetails && canManageFormation(match.teams[index])">
                        <template #icon="{item: user}">
                            <div class="number-circle ml-2">
                                <div v-if="user.shirt_number">{{ user.shirt_number }}</div>
                                <div class="checkmark-circle" v-if="isPresent(index, user.id)">
                                    <span class="checkmark">✔</span>
                                </div>
                            </div>
                        </template>
                        <template #no-items>
                            <div class="text--disabled ml-4">
                                {{$translate('No players added to formation')}}
                            </div>
                        </template>
                    </multi-column-list>
                    <div v-if="canManageFormation(match.teams[index])" class="d-flex z-clickable mt-2" key="add" @click="showManageFormationDialog(match.teams[index])">
                        <div class="mr-2">
                            <v-icon color="primary">mdi-plus-circle</v-icon>
                        </div>
                        <div class="mb-2">
                            <div>{{ $translate('Manage formation') }}</div>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <teamsport-invite-players-dialog v-model="manageFormation.show" :referee="isReferee" :match="match" :teamId="manageFormation.teamId" :group="manageFormation.group" :activity="manageFormation.activity" v-if="manageFormation.show"/>
            <TeamsportEventDialog v-model="addEventDialog.show" :match="match" :eventTypeId="addEventDialog.eventTypeId" :teamId="addEventDialog.teamId"  v-if="addEventDialog.show" />
            <TeamsportEventDialog v-model="changeEventDialog.show" :match="match" :eventId="changeEventDialog.eventId" v-if="changeEventDialog.show" />
            <TeamsportPlayerDetailsDialog :user="playerDetails.user" :match="match" :teamId="playerDetails.teamId" :attendance="attendance[playerDetails.teamId]" v-if="playerDetails.show" v-model="playerDetails.show" :showAtX="playerDetails.x" :showAtY="playerDetails.y" @updateAttendance="updateAttendance" />
            <TeamsportSetResultDialog v-model="showSetResultDialog" :match="match" v-if="showSetResultDialog" />
        </div>
        <div v-else>
            <TeamsportOneMatch :matchId="match.id" />
        </div>
    </div>
</template>

<script>
import TeamsportMatchResult from './TeamsportMatchResult.vue';
import MultiColumnList from './MultiColumnList.vue';
import TeamsportEventDialog from './TeamsportEventDialog.vue';
import TeamsportPlayerDetailsDialog from './TeamsportPlayerDetailsDialog.vue';
import TeamsportSetResultDialog from './TeamsportSetResultDialog.vue'
import TeamsportOneMatch from './TeamsportOneMatch.vue';
import TeamsportInvitePlayersDialog from './TeamsportInvitePlayersDialog.vue'
import {debounce} from 'lodash';
export default {
    name: 'zoezi-teamsport-match',

    zoezi: {
        title: 'Match',
        icon: 'mdi-trophy',
        addon: 'TeamSports'
    },

    props: {
        matchId: {
            title: 'Match ID',
            type: Number
        }
    },

    components: {
        TeamsportMatchResult,
        MultiColumnList,
        TeamsportEventDialog,
        TeamsportPlayerDetailsDialog,
        TeamsportSetResultDialog,
        TeamsportOneMatch,
        TeamsportInvitePlayersDialog
    },

    data: () => ({
        match: null,
        loading: false,
        unsubscribe: [],
        eventTypes: [],
        rawEvents: [],
        members: [],
        settings: null,
        addEventDialog: {
            show: false,
            eventTypeId: null,
            teamId: null
        },
        changeEventDialog: {
            show: false,
            eventId: null
        },
        playerDetails: {
            show: false,
            user: null,
            teamId: null,
            x: null,
            y: null
        },
        manageFormation: {
            show: false,
            teamId: null,
            group: {},
            activity: {}
        },
        attendance: {},
        showSetResultDialog: false
    }),

    watch: {
        matchId: {
            immediate: true,
            handler() {
                this.getMatchAndMembers();
            }
        },
        match() {
            this.getMembersInMatch();
            this.getAttendance();
        }
    },

    computed: {
        showUserDetails() {
            return this.$store.state.user && (this.$api.hasPermission('Competition handling') || this.isTeamLeader || this.isReferee);
        },
        events() {
            if (!this.rawEvents || !this.eventTypes) {
                return [];
            }
            return this.rawEvents
                .filter(event => event.eventtype_id)
                .map(event => {
                    const eventType = this.eventTypes.find(x => x.id == event.eventtype_id);
                    return {
                        id: event.id,
                        title: eventType.name,
                        subtitle: event.comment,
                        time: event.matchtime,
                        color: eventType.text_color,
                        background_color: eventType.background_color,
                        home: event.team_id == this.match.teams[0].id,
                        comment: event.comment,
                        timeperiod: event.timeperiod,
                        user: this.getUsers(event.team_id == this.match.teams[0].id ? 0 : 1).find(x => x.id == event.user_id)
                    }
                }).sort((a, b) => b.time - a.time);
        },
        groupedEvents() {
            let res = {}
            this.timePeriods.forEach(tp => {
                res[tp.id] = this.events.filter(x => x.timeperiod == tp.id);
            })
            return res;
        },
        homeLeaders() {
            return this.getLeaders(0);
        },
        awayLeaders() {
            return this.getLeaders(1);
        },
        eventTypesForSport() {
            return this.match.division.competitionstep.gameclass.competition.teamsport.eventtypes.map(eventtype_id => {
                return this.eventTypes.find(x => x.id == eventtype_id);
            }).filter(x => x?.team).sort((a, b) => a.name.localeCompare(b.name));
        },
        canLiveReport() {
            return this.settings?.live_report && this.canReportEvent();
        },
        canLiveReportForHomeTeam() {
            return this.canLiveReport && this.match && this.canReportEvent(this.match.teams[0]);
        },
        canLiveReportForAwayTeam() {
            return this.canLiveReport && this.match && this.canReportEvent(this.match.teams[1]);
        },
        teamsSet() {
            return !this.match.teams.some(team => !team.id);
        },
        canReportResult() {
            if (!this.$store.state.user) {
                return false;
            }

            if (!this.teamsSet) {
                return false;
            }

            if (this.$api.hasPermission('Competition handling')) {
                return true;
            }

            if (!this.settings) {
                return false;
            }

            const isReferee = this.match.referees_id && this.match.referees_id.includes(this.$store.state.user.id);
            const timeOk = this.match.activity && this.$store.state.now30s < Date.newFull(this.match.activity.endTime).addDays(this.settings.result_report_days);
            const refereeCanReport = ['both', 'result'].includes(this.settings.referee_report);
            const teamLeaderCanReport = ['both', 'both_team', 'result'].includes(this.settings.teamleader_report);
            return (isReferee && refereeCanReport) || (this.isTeamLeader && teamLeaderCanReport) && (!this.match.finished || timeOk);
        },
        timePeriods() {
            let timeperiods = this.match.division.competitionstep.gameclass.competition.teamsport.timeperiods || '';
            let res = timeperiods.split(',').reverse();
            res.push(null)
            return res.map(id => {
                return {
                    id,
                    title: id || this.$translate('No period')
                }
            })
        },
        isTeamLeader() {
            return this.$store.state.user && this.match.teams.some(team => team.group && team.group.responsible.includes(this.$store.state.user.id));
        },
        referees() {
            if (!this.match || !this.members.length) {
                return [];
            }
            return this.match.referees_id.map(id => {
                const user = this.members.find(x => x.id == id);
                return {
                    name: user.name,
                    id: user.id,
                    phone: user.phone,
                    mail: user.mail
                }
            }).sort((a, b) => a.name.localeCompare(b.name));
        },
        twoTeams() {
            return this.match?.teams.length == 2;
        },
        isReferee() {
            return this.$store.state.user && this.match.referees_id && this.match.referees_id.includes(this.$store.state.user.id);
        },
        isIndividualCompetition() {
            return this.match.division.competitionstep.gameclass.individual;
        },
        questions() {
            return this.match.division.competitionstep.gameclass.questions?.filter(q => q.show_on_match) ?? [];
        }
    },

    methods: {
        canManageFormation(team) {
            const refereeResponsible = this.match.division.competitionstep.gameclass.competition.teamsport.referee_responsible_for_formations
            const teamResponsible = team.group?.responsible?.includes(this.$store.state.user?.id);
            return teamResponsible || (refereeResponsible && this.isReferee);
        },
        showManageFormationDialog(team) {
            this.manageFormation.show = true;
            this.manageFormation.teamId = team.id;
            this.manageFormation.group = team.group;

            const teamIndex = this.match.teams.findIndex(x => x.id == team.id);
            this.manageFormation.activity = this.match.team_activities[teamIndex];
        },
        getMatchAndMembers() {
            this.loading = true;

            Promise.all([this.getMatch(), this.getMembersInMatch()]).then(() => {
                this.loading = false;
            });
        },
        getMatch() {
            return this.$api.get('/api/teamsport/match/get', {id: this.matchId, full: true}).then(match => {
                this.match = match;
                if (match.activity) {
                    this.$booking.transformWorkout(match.activity);
                }
            }, () => {
                this.match = null;
            });
        },
        getMembersInMatch() {
            return this.$api.get('/api/memberapi/teamsport/get_member_in_match', {match_id: this.matchId}).then(members => {
                this.members = members;
            })
        },
        getEvents() {
            this.$api.get('/api/teamsport/event/get', {match_id: this.matchId}).then(events => {
                this.rawEvents = events;
            })
        },
        getEventTypes() {
            this.$api.get('/api/teamsport/eventtype/get').then(eventTypes => {
                this.eventTypes = eventTypes;
            })
        },
        addEvent(teamId, eventTypeId) {
            this.addEventDialog.teamId = teamId;
            this.addEventDialog.eventTypeId = eventTypeId;
            this.addEventDialog.show = true;
        },
        getUserShirtNumber(teamId, userId) {
            let match_number = this.match.shirt_numbers?.find(user => user.user == userId && user.team == teamId);
            let group_number = this.match.teams.find(team => team.id == teamId)?.group?.shirt_numbers?.find(user => user.user_id == userId);

            return match_number?.shirt || group_number?.shirt || null;
        },
        getUsers(index) {
            if (!this.match || !this.members.length) {
                return [];
            }

            return this.match.team_activities[index].bookings.map(booking => {
                const user = this.members.find(x => x.id == booking.user_id);
                return {
                    name: user.name,
                    id: user.id,
                    shirt_number: this.getUserShirtNumber(this.match.teams[index].id, user.id),
                    phone: user.phone,
                    mail: user.mail
                }
            }).sort((a, b) => a.name.localeCompare(b.name));
        },
        getLeaders(index) {
            if (!this.match || !this.members.length || index >= this.match.teams.length || !this.match.teams[index].group) {
                return [];
            }

            return this.match.teams[index].group.responsible.map(user_id => {
                const user = this.members.find(x => x.id == user_id);
                return {
                    name: user.name,
                    id: user.id,
                    phone: user.phone,
                    mail: user.mail,
                    user_type: this.match.teams[index].group.user_types?.[user.id]
                }
            }).sort((a, b) => a.name.localeCompare(b.name));
        },
        fetchTeamsportSettings() {
            this.$api.get('/api/teamsport/settings/get').then(settings => {
                this.settings = settings;
            })
        },
        canReportEvent(forTeam) {
            if (!this.$store.state.user) {
                return false;
            }

            if (!this.match) {
                return false;
            }

            if (this.match.teams.some(team => !team.id)) {
                return false;
            }

            if (this.$api.hasPermission('Competition handling')) {
                return true;
            }

            if (!this.settings) {
                return false;
            }

            const isTeamLeader = this.isTeamLeader;
            const isTeamLeaderForTeam = !forTeam || (forTeam.group && forTeam.group.responsible.includes(this.$store.state.user.id));
            const timeOk = this.match.activity && this.$store.state.now30s < Date.newFull(this.match.activity.endTime).addDays(this.settings.event_report_days);
            const refereeCanReport = ['both', 'event'].includes(this.settings.referee_report);
            const teamLeaderCanReportForAll = ['both', 'event'].includes(this.settings.teamleader_report);
            const teamLeaderCanReportForOwn = ['both_team', 'event_team'].includes(this.settings.teamleader_report);
            const teamLeaderCanReport = teamLeaderCanReportForAll || (teamLeaderCanReportForOwn && isTeamLeaderForTeam);

            return ((this.isReferee && refereeCanReport) || (isTeamLeader && teamLeaderCanReport)) && (!this.match.finished || timeOk);
        },
        changeEvent(event) {
            if(!this.canReportEvent(this.match.teams.find(x => x.id == event.team_id))) {
                return;
            }
            this.changeEventDialog.eventId = event.id;
            this.changeEventDialog.show = true;
        },
        showPlayerDetails(user, teamId, $event) {
            if (this.showUserDetails && this.canManageFormation(this.match.teams.find(x => x.id == teamId))) {
                this.playerDetails.show = true;
                this.playerDetails.user = user;
                this.playerDetails.teamId = teamId;

                if (this.$vuetify.breakpoint.mobile) {
                    this.playerDetails.x = (window.innerWidth - 275) / 2;
                    this.playerDetails.y = $event.clientY + 40;
                } else {
                    // If has space to the left, put it there
                    if ($event.clientX > 285) {
                        this.playerDetails.x = $event.clientX - 285;
                        this.playerDetails.y = $event.clientY;
                    } else {
                        this.playerDetails.x = $event.clientX + 100;
                        this.playerDetails.y = $event.clientY;
                    }
                }
                this.playerDetails.x -= 15
                this.playerDetails.y -= 15
            }
        },
        getAttendance() {
            if (!this.match || !this.$store.state.user) {
                return;
            }
            const teamLeaderTeams = this.match.teams.filter(team => this.isReferee || team?.group?.responsible?.includes(this.$store.state.user.id));
            teamLeaderTeams.forEach(team => {
                let index = this.match.teams.findIndex(x => x.id == team.id)
                const teamActivity = this.match.team_activities[index];
                this.$api.get('/api/memberapi/teamsport/attendance/get', {activityId: teamActivity.id}).then(attendance => {
                    this.$set(this.attendance, team.id, attendance);
                })
            })
        },
        updateAttendance(teamId, data) {
            let o = this.attendance[teamId].find(x => x.id == data.id)
            if (o) {
                o.present = data.present;
            }

            // FIXME: Perhaps fetch the attendance again?
        },
        isPresent(teamIndex, userId) {
            const teamId = this.match.teams[teamIndex].id;
            if (!this.attendance[teamId]) {
                return false;
            }
            return this.attendance[teamId].find(x => x.user.id == userId)?.present;
        }
    },
    mounted() {
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsportmatch', callback: (_, event) => {
            if (this.match && event.data.find(x => x.id == this.match.id)) {
                this.getMatchAndMembers();
            }
        }}))
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsportevent', callback: (_, event) => {
            if (this.match && event.data.find(x => x.match_id == this.match.id)) {
                this.getEvents();
            }
        }}))
        this.unsubscribe.push(this.$api.subscribe({type: 'settings:teamsportsettings', callback: () => {
            this.fetchTeamsportSettings();
        }}));
        this.unsubscribe.push(this.$api.subscribe({type: 'workoutbooking', callback: (_, event) => {
            if (!this.match || !this.$store.state.user) {
                return;
            }

            const teamActivityIds = this.match.team_activities.map(activity => activity.id);

            // Check if the event data includes any of the team activity IDs
            const relevantBooking = event.data.find(x => teamActivityIds.includes(x.workout));
            if (relevantBooking) {
                this.getAttendanceAndMatchDebounce();
            }
        }}));
        this.getEventTypes()
        this.getEvents();
        this.fetchTeamsportSettings();
    },
    destroyed() {
        this.unsubscribe.forEach(x => x());
    },
    beforeCreate() {
        this.getAttendanceAndMatchDebounce = debounce(() => {
            this.getAttendance();
            this.getMatchAndMembers();
        }, 500);
    }
}
</script>
